import { useLanguage } from './../../../../../utilities/LanguageContext'


const VerticalVideo = ({ instrument }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto

    
    return (
        <video className='Video-Video' controls>
            <source src={instrument.video.verticalFile} type='video/mp4' />
            {translate('labels.viewer.videos.tagLegend')}

            <track src={instrument.video.subtitles} kind="subtitles" srcLang="es" label="Español" default />
        </video>
    )
}

export { VerticalVideo };